import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { getReleaseList } from '@/service/proRequisition';
export default function userList(params) {
  var loading = ref(false);
  var finished = ref(false);
  var list = ref([]);
  var getReleaseListAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data, _list$value;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            loading.value = true;
            _context.next = 4;
            return getReleaseList(params.value);
          case 4:
            data = _context.sent;
            if (data.data) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return");
          case 7:
            if (params.value.page === 1) {
              list.value = data.data;
            } else {
              (_list$value = list.value).push.apply(_list$value, _toConsumableArray(data.data));
            }
            // 数据全部加载完成
            if (data.total === list.value.length) {
              finished.value = true;
            }
            // 加载状态结束
            loading.value = false;
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            params.value.page -= 1;
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 12]]);
    }));
    return function getReleaseListAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var onLoad = function onLoad() {
    params.value.page += 1;
    getReleaseListAsync();
  };
  return [list, loading, finished, getReleaseListAsync, onLoad];
}